import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CommonService } from "src/app/services/common.service";
import { GlobalVariable } from "../../../app.component";
import { DataService, Response } from "./../../../dataService/data.service";

@Component({
  selector: "app-tile-statistics",
  templateUrl: "./tile-statistics.component.html",
  styleUrls: [
    "./tile-statistics.component.scss",
    "./../../review-statistics/review-statistics.component.scss",
  ],
})
export class TileStatisticsComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  appointmentDetail: any;
  view: number[];
  chartData: any[];
  myColors: { name: string; value: string }[];
  mystoreDetail: any;
  isAppointment: boolean;
  outlet_id: string;
  @Input() data: any;
  @Input() mystoreData: any;
  @Input() isAnyAppointmentData: boolean;
  totalChartDataCount: number = 0;

  constructor(
    private router: Router,
    private HttpService: DataService,
    private commonService: CommonService,

    @Inject(LOCAL_STORAGE) private storage: WebStorageService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outlet_id = this.storage.get("outlet_id");
    if (window.innerWidth < 768) {
      this.view = [innerWidth / 1.2, 250];
    } else {
      this.view = [innerWidth / 3.0, 200];
    }
    if (this.router.url === "/dashboard/mystore") {
      this.getOrderDetails();
    } else if (this.router.url === "/dashboard/appointments") {
      this.getAppointmentDetails();
    }
  }

  getAppointmentDetails() {
    let res: Response;
    // this.commonservice.getAppointmentBottomPanel(res);
    console.log(this.data.data);
    if (this.data) {
      this.appointmentDetail = this.data.data;
      this.isAppointment = true;

      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var today = this.commonService.getDate();
      var d;
      var month;
      this.chartData = [];
      for (var i = 6; i >= 0; i -= 1) {
        d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        month = monthNames[d.getMonth()];
        this.chartData.push({
          name: month.substring(0, 3),
          series: [
            {
              name: "Appointments",
              value:
                this.appointmentDetail.appointments_per_month[month]
                  ?.appointments,
            },
            {
              name: "Enquiries",
              value:
                this.appointmentDetail.appointments_per_month[month]?.enquiries,
            },
          ],
        });
      }
    }

    this.myColors = [
      { name: "Appointments", value: "#03c0c2" },
      { name: "Enquiries", value: "#74d8ee" },
    ];

    this.totalChartDataCount =
      this.appointmentDetail?.business_appointments +
      this.appointmentDetail?.customer_appointments +
      this.appointmentDetail?.total_enquiry_count;
    this.loading = false;
  }

  getOrderDetails() {
    let res;
    // this.HttpService.getRequest({ customApiUrl: this.BASE_URL.VIEW_MYSTORE_BOTTOM_TILE(this.outlet_id) })
    res = this.mystoreData;
    if (res) {
      if (res.code == 200) {
        this.mystoreDetail = res.data;
        this.isAppointment = false;

        //           appointment_details: []
        // appointments_per_month: {December: 0, January: 0, February: 0, March: 0, April: 0, …}
        // business_appointments: 0
        // customer_appointments: 0
        // mom: 0
        var monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var today = this.commonService.getDate();
        var d;
        var month;
        this.chartData = [];
        for (var i = 6; i >= 0; i -= 1) {
          d = new Date(today.getFullYear(), today.getMonth() - i, 1);
          month = monthNames[d.getMonth()];
          this.chartData.push({
            name: month.substring(0, 3),
            series: [
              {
                name: "orders",
                value: this.mystoreDetail.orders_per_month[month],
              },
            ],
          });
        }

        this.myColors = [
          // { name: 'Request sent', value: '#EAEAEA' },
          { name: "orders", value: "#03c0c2" },
        ];
        this.loading = false;
      }
    }
  }
}
